import $ from 'jquery';

import 'slick-carousel';
import { isRTL } from '../utils/rtl';

$(window).on('load', function () {
    const $wrapper = $('#lottery-desktop .lottery-carousel-wrapper');
    const $carousel = $wrapper.find('.lottery-carousel');

    if ($carousel.length) {
        $carousel.slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: false,
            dots: false,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1350,
                    settings: { slidesToShow: 4, slidesToScroll: 4, infinite: true },
                },
            ],
            rtl: isRTL(),
        });

        $wrapper.addClass('loaded');
    }

    $wrapper.on('click', '.custom-prev', function () {
        $carousel.slick('slickPrev');
    });

    $wrapper.on('click', '.custom-next', function () {
        $carousel.slick('slickNext');
    });
});
